import React, { useState } from "react";
import Popup from "reactjs-popup";
import { GrRevert } from "react-icons/gr";
import rightArrowIcon from "../../Assets/Icons/right_arrow.png";
import leftArrowIcon from "../../Assets/Icons/left_arrow.png";
import LazyImage from "../LazyImage";
import StatsBar from "../StatsBar";
import UnableUnidentifyTigers from "./UnableUnidentifyTigers";
import { Select } from "antd";

const TigerCard = ({
  tiger,
  index,
  isPopupOpen,
  clickedTiger,
  setIsPopupOpen,
  fetchAdditionalImages,
  tigerData,
  selectedTigerIndex,
  selectedTiger,
  handleLeftArrowClick,
  handleRightArrowClick,
  activeButton,
  handleNameClick,
  identifyHandler,
  tigerIds,
  selectedIndex,
  setSelectedIndex,
  handlePrev,
  handleNext,
  revertTigerIdentification,
  isIdentified,
  setUnIdentifiedTigers,
  unIdentifiedTigers,
  tigerslist,
  loading,
}) => {
  const [isUnableMode, setIsUnableMode] = useState(false);
  const [selectedListTiger, setSelectedListTiger] = useState(null);

  const onUnableIdentified = () => {
    handleNext(selectedIndex, setSelectedIndex, tigerIds);
  };
  const [selectedMatchedTiger, setSelectedMatchedTiger] = useState(null);
  const [selectedUnableTigerIndex, setSelectedUnableTigerIndex] = useState(0);

  const handleLeft = () => {
    if (selectedUnableTigerIndex > 0) {
      setSelectedUnableTigerIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleRight = () => {
    const totalImages = selectedMatchedTiger?.images.length || 0;
    if (selectedUnableTigerIndex < totalImages - 1) {
      setSelectedUnableTigerIndex((prevIndex) => prevIndex + 1);
    }
  };

  const tigerSelectionHandler = (event) => {
    setSelectedListTiger(event);
  };

  return (
    <div
      key={index}
      className="Individual_Image"
      style={{
        width: "20%",
        height: "20%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <LazyImage
        src={isIdentified ? tiger.image : tiger.fileName}
        alt={tiger.id}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {tiger.species_name && <span>{tiger.species_name} *</span>}
        <Popup
          open={isPopupOpen && clickedTiger === tiger.id}
          onClose={() => setIsPopupOpen(false)}
          trigger={
            <div
              style={{
                marginTop: "-5px",
              }}
            >
              <div
                className="Classify_Section Classify_Header Classify_Upload"
                onClick={() =>
                  fetchAdditionalImages(
                    isIdentified ? "identified" : "unidentified",
                    tiger.id
                  )
                }
              >
                <span style={{ cursor: "pointer" }}>
                  {tiger.checked ? "Identified" : "Identify Tiger"}
                </span>
              </div>
            </div>
          }
          modal
          nested
        >
          {(close) => (
            <div className="tiger-card-container">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  className="half"
                  style={{
                    width: "45%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1vh",
                  }}
                >
                  <span>Uploaded Image</span>
                  <LazyImage
                    src={isIdentified ? tiger.image : tiger.fileName}
                    alt="image 1"
                    zoomModeEnable={true}
                  />
                </div>

                <div
                  className="half"
                  style={{
                    width: "45%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1vh",
                  }}
                >
                  <span>
                    Matching Tigers (
                    {isUnableMode
                      ? selectedMatchedTiger?.name
                      : tigerData[selectedTigerIndex]?.name}
                    )
                  </span>
                  {isUnableMode ? (
                    <>
                      {selectedMatchedTiger?.images.length > 0 > 0 && (
                        <LazyImage
                          src={
                            selectedMatchedTiger?.images[
                              selectedUnableTigerIndex
                            ]
                          }
                          loading="lazy"
                          alt="Tiger image"
                          zoomModeEnable={true}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {tigerData.length > 0 && (
                        <LazyImage
                          src={selectedTiger}
                          loading="lazy"
                          alt="Tiger image"
                          zoomModeEnable={true}
                        />
                      )}
                    </>
                  )}

                  {isUnableMode ? (
                    <>
                      {selectedMatchedTiger?.images.length > 0 && (
                        <>
                          <img
                            src={leftArrowIcon}
                            alt="Left Arrow"
                            className="arrow left-arrow"
                            onClick={handleLeft}
                          />
                          <img
                            src={rightArrowIcon}
                            alt="Right Arrow"
                            className="arrow right-arrow"
                            onClick={handleRight}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {tigerData[selectedTigerIndex]?.images.length > 0 && (
                        <>
                          <img
                            src={leftArrowIcon}
                            alt="Left Arrow"
                            className="arrow left-arrow"
                            onClick={handleLeftArrowClick}
                          />
                          <img
                            src={rightArrowIcon}
                            alt="Right Arrow"
                            className="arrow right-arrow"
                            onClick={handleRightArrowClick}
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>

              {isUnableMode ? (
                <UnableUnidentifyTigers
                  selectedTiger={tiger}
                  setIsUnableMode={setIsUnableMode}
                  onUnableIdentified={onUnableIdentified}
                  selectedMatchedTiger={selectedMatchedTiger}
                  setSelectedMatchedTiger={setSelectedMatchedTiger}
                  setUnIdentifiedTigers={setUnIdentifiedTigers}
                  unIdentifiedTigers={unIdentifiedTigers}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ flex: 1, marginTop: "2vh" }}>
                      {tigerData.map((tiger, index) => (
                        <StatsBar
                          key={tiger.name}
                          score={tiger.matching_score * 100}
                          isActive={tiger.name === activeButton}
                          onClick={() => handleNameClick(tiger.name)}
                          name={tiger.name}
                        />
                      ))}
                    </div>
                  </div>

                  <div style={{ flex: 1, marginLeft: "4vw" }}>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "2vh",
                        gap: "1vw",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      {isIdentified && !tiger.checked && (
                        <div
                          onClick={() => {
                            revertTigerIdentification();
                          }}
                          className="revert_button"
                        >
                          <GrRevert style={{ fontSize: "1rem" }} />
                          <span>Unidentify Image</span>
                        </div>
                      )}
                      {!isIdentified && !tiger.checked && (
                        <button
                          className="IdentifyButton Identified"
                          onClick={() => {
                            setIsUnableMode(true);
                          }}
                        >
                          Nearby Tigers
                        </button>
                      )}
                      <button
                        className="IdentifyButton Identified"
                        onClick={() =>
                          identifyHandler(
                            tiger.id,
                            tigerData[selectedTigerIndex]?.id,
                            isIdentified ? "identified" : "unidentified"
                          )
                        }
                        disabled={tiger.checked || selectedListTiger}
                        style={{
                          cursor:
                            tiger.checked || selectedListTiger
                              ? "no-drop"
                              : "pointer",
                          backgroundColor:
                            tiger.checked || selectedListTiger
                              ? "#C0C0C0"
                              : undefined,
                        }}
                      >
                        {tiger.checked ? "Saved" : "Save"}
                      </button>
                    </div>

                    {!tiger.checked && (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        >
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              height: "0.5px",
                              backgroundColor: "grey",
                            }}
                          />
                          <span
                            style={{
                              margin: "0 10px",
                              fontSize: "0.7rem",
                              color: "#555",
                            }}
                          >
                            Or
                          </span>
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              height: "0.5px",
                              backgroundColor: "grey",
                            }}
                          />
                        </div>

                        <p style={{ fontSize: "0.6rem" }}>
                          *** Can’t identify the tiger in the images? Try
                          selecting from the list of known tigers ***
                        </p>
                        <div
                          style={{
                            display: "flex",
                            gap: "2vw",
                            marginTop: "2.5vh",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <Select
                              showSearch
                              style={{ width: 200 }}
                              placeholder="Select Tiger Name"
                              optionFilterProp="children"
                              size={"Medium"}
                              value={selectedListTiger}
                              onChange={tigerSelectionHandler}
                              allowClear={true}
                              loading={loading}
                              filterOption={(input, option) =>
                                (option?.label ?? "").includes(input)
                              }
                              options={tigerslist}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "end" }}>
                            <button
                              className="IdentifyButton Identified"
                              style={{
                                cursor: !selectedListTiger
                                  ? "no-drop"
                                  : "pointer",
                                backgroundColor: !selectedListTiger
                                  ? "#C0C0C0"
                                  : undefined,
                              }}
                              onClick={() =>
                                identifyHandler(
                                  tiger.id,
                                  selectedListTiger,
                                  isIdentified ? "identified" : "unidentified"
                                )
                              }
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: "2vh" }}>
                <div className="control-btn-container">
                  <button
                    disabled={tigerIds.indexOf(selectedIndex) === 0}
                    style={{
                      backgroundColor:
                        tigerIds.indexOf(selectedIndex) === 0
                          ? "#C0C0C0"
                          : "#EDF3F2",
                      cursor:
                        tigerIds.indexOf(selectedIndex) === 0
                          ? "no-drop"
                          : "pointer",
                    }}
                    className="control-btn"
                    onClick={() =>
                      handlePrev(selectedIndex, setSelectedIndex, tigerIds)
                    }
                  >
                    Prev
                  </button>
                  <button
                    disabled={
                      tigerIds.indexOf(selectedIndex) === tigerIds.length - 1
                    }
                    style={{
                      backgroundColor:
                        tigerIds.indexOf(selectedIndex) === tigerIds.length - 1
                          ? "#C0C0C0"
                          : "#EDF3F2",
                      cursor:
                        tigerIds.indexOf(selectedIndex) === tigerIds.length - 1
                          ? "no-drop"
                          : "pointer",
                    }}
                    className="control-btn"
                    onClick={() =>
                      handleNext(selectedIndex, setSelectedIndex, tigerIds)
                    }
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </Popup>
      </div>
    </div>
  );
};

export default TigerCard;
